import React, { Fragment } from 'react';

const OrganizationSelectList = ({ organizationList, onOrgSubmit, translate, selectedOrg, selectOnChange }) => (
    <div className="select-org__interaction">
        <select className="select-org-list" onChange={ event => selectOnChange(event.target.value)} id="selectOrganizationList" value={selectedOrg.id} >
            {organizationList && organizationList.map((item, index, array) => (
                <Fragment key={`${item.name}-${index}`}>
                    <option key={index} value={item.id}>{item.name}</option>
                </Fragment>
            ))}
        </select>
        <button className="select-org__submit-button" type="button" onClick={e => onOrgSubmit()}>
            <span className="select-org__submit-title">{translate('organization.change')}</span>
        </button>
    </div>
)

export default OrganizationSelectList;
